import * as log from 'loglevel';
import {game} from '../GameCore';
import {getGameManager} from '../GameManager';
import {gameState} from '../config/GameState';
import {stopStageTimer} from '../level/stages/StageManager';
import {showSecondaryScreen} from '../../screens/ScreenManager';
import {gameConfig} from '../config/GameConfig';
import {slowToStandstill} from '../sprites/player/Player';

var timerEvent: Phaser.TimerEvent;


/**
 * reset the game timer countdown
 */
export function resetCountdownTimer()
{
    //  reset the countdown clock

    getGameManager().setTimeRemaining(gameConfig.game.startTimeRemaining);

    //  start the timer

    startCountdownTimer();
}


/**
 * start the timer by adding a timer event
 */
export function startCountdownTimer()
{
    //  stop the timer if one is running

    stopCountdownTimer();

    //  add a new timer event

    timerEvent = game.time.events.loop(1000, onTimerTick);
}


/**
 * when the timer ticks down
 */
function onTimerTick()
{
    var timeRemaining: number;

    //  increment the time remaining

    timeRemaining = getGameManager().incrementTimeRemaining(-1);

    log.debug('time:', timeRemaining)

    //  check the time remaining

    if (timeRemaining > 0) return;

    //  out of time!

    getGameManager().gameOverMessage('You ran out of time!');

    //gameState.player.isControllable = false;

    slowToStandstill();

    stopCountdownTimer();

    stopStageTimer();

    //  show game over screen

    //setTimeout(() => showSecondaryScreen('game-over'), 1500);
}


/**
 * stop the timer by removing the timer event
 */
export function stopCountdownTimer()
{
    if (timerEvent) game.time.events.remove(timerEvent);
}


// WEBPACK FOOTER //
// ./src/ts/game/timer/GameTimer.ts